<template>
  <!-- <base-page> -->
  <DevizProduse   ref="deviz_produse" />
  <!-- </base-page> -->
</template>

<script>
import settings from "@/backend/LocalSettings";
// import BasePage from "@/pages/Admin/BasePage";
import DevizProduse from '@/components/Deviz_produse';

export default {
  name: "masini",
  // extends: BasePage,
  components: {
    // "base-page": BasePage,
    DevizProduse,
  },
  data() {
    return {
     
    };
  },
  methods: {

  },
  mounted() {
    if (!this.$has_right('Mecanic') && !this.$has_right('Supervizor')){
      this.$router.push('/no-rights')
      return
    }
    this.base_url = settings.BASE_URL;
  },
};
</script>

<style lang="less" scoped>

</style>
